// --------------------------------------------------
//   Local IndexedDB
// --------------------------------------------------

export const DB_NAME = "fontan_recordings_db";
export const OS_NAME = "fontan_recordings_os";
